import React, { useEffect, useState, useRef } from 'react'
import { useNavigate, Link, Navigate } from "react-router-dom";
import {useDispatch, useSelector} from 'react-redux'
import { OrderAcceptAction, OrderReadyAction, OrderRequestDeliveryAction, OrderDetailIdAction, OrderOngoingAction, OrderCompletedAction, OrderPickedupAction, OrderAssigningAction, OrderCancelDeliveryAction } from '../../redux/actions/OrderAction'
import {useReactToPrint} from 'react-to-print';
import { ComponentToPrint } from '../Print'
import { AllReceiptToPrint } from '../Receipt/Allreceipt'
import moment from 'moment';
import CancelModal from '../Modal/CancelModal'
import OptionModal from '../Modal/OptionModal'
import PrintModal from '../Modal/PrintModal'

const OrderDetail = ({loadData}) => {
  const dispatch = useDispatch()
  const componentRef = useRef();
  const allReceiptRef = useRef();
  const [orderAccept, setOrderAccept] = useState(false)
  const [laterorder, setLaterorder] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isOptions, setIsOptions] = useState(false)
  const [printModal, setPrintModal] = useState(false)
  const { singleOrder } = useSelector(state=>state.singleOrderDetails)
  const { isAccept } = useSelector(state=>state.acceptOrder)
  const { userInfo } = useSelector(state=>state.userLogin)
  const whatsapp_url  = 'https://api.whatsapp.com/send?phone='
  const navigate = useNavigate()

  const getOrderTime = () => {
    var a = moment(singleOrder?.created_at).format('lll')
    var b = moment().format('lll') 
    var minute = moment(b).diff(a, 'minutes')
    var hour = moment(b).diff(a, 'hours')
    var day = moment(b).diff(a, 'days')
      if(day < 0){
        return moment(b).diff(a, 'hours') + " " + "hours"
      }else if(day==1){
        return moment(b).diff(a, 'days') + " " + "day"
      }else if(hour < 24){
        return moment(b).diff(a, 'minutes') + " " + "mins"
      }else{
        return moment(b).diff(a, 'days') + " " + "days"
      }
  }

  const handlePrint = useReactToPrint({
    content: () => allReceiptRef.current,
    // onAfterPrint: () =>  window.location.reload(true)
  });

  const handleClick = (event, id) =>{
    event.preventDefault()
    dispatch(OrderReadyAction(id))
    if(typeof loadData === 'function'){
      setTimeout(()=> {
        loadData()
      }, 500) 
    }
  }

  const handleClickOngoing = (event, id) =>{
    event.preventDefault()
    dispatch(OrderOngoingAction(id))
    if(typeof loadData === 'function'){
      setTimeout(()=> {
        loadData()
      }, 500) 
    }
  }

  const handleClickCancelDelivery = (event, id) =>{
    event.preventDefault()
    dispatch(OrderCancelDeliveryAction(id))
    // if(typeof loadData === 'function'){
    //   setTimeout(()=> {
    //     loadData()
    //   }, 500) 
    // }
    window.location.reload();
  }

  const handleClickPickedup = (event, id) =>{
    event.preventDefault()
    dispatch(OrderPickedupAction(id))
    if(typeof loadData === 'function'){
      setTimeout(()=> {
        loadData()
      }, 500) 
    }
  }

  const handleClickCompleted = (event, id) =>{
    event.preventDefault()
    dispatch(OrderCompletedAction(id, userInfo?.id))
    if(typeof loadData === 'function'){
      setTimeout(()=> {
        loadData()
      }, 500) 
    }
  }

  const handleRequestDriver = (event, id) => {
    event.preventDefault()
    dispatch(OrderRequestDeliveryAction(id))
    if(typeof loadData === 'function'){
      setTimeout(()=> {
        loadData()
      }, 500) 
    }
  }

  const handleSubmit = (event, id) => {
    event.preventDefault()
    handlePrint()
    dispatch(OrderAcceptAction(id))
    if(typeof loadData === 'function'){
      setTimeout(()=> {
        loadData()
      }, 500) 
    }
  }

  useEffect (()=>{
    if (isAccept == true){
      navigate('/orders')
    }
  }, [])

  return (
    <div className="order_detail_heading">
      <div className="order_detail_heading_top">
        <div className="order_detail_heading_nav">
            <Link to={'/orders/'+ singleOrder?.id} >
                <div className="order_detail_heading_nav1">
				      		<p className="order_detail_heading_nav1_p">{singleOrder?.id}</p>
                </div>
			     </Link>
          <div className="order_detail_heading_nav2">
            {getOrderTime()}
          </div>
        </div>
        <div className="order_detail_heading_2nav">
          <div className="order_detail_heading_nav3">
            {console.log("Order Status:", singleOrder?.status)} {/* Debugging status */}

            {singleOrder?.status === "DRIVER IS ON THE WAY" ? (
              <>
                {/* PICKED UP button */}
                {/* <Link
                  to=""
                  className="order_detail_heading_nav3_link2"
                  style={{ display: "inline-block", margin: "5px", border: "1px solid red" }} // Debug styling
                  onClick={(event) => handleClickPickedup(event, singleOrder?.id)}
                >
                  PICKED UP
                </Link> */}

                {/* CANCEL DELIVERY button */}
                <Link
                  to=""
                  className="order_detail_heading_nav3_link1"
                  style={{ display: "inline-block", margin: "5px", border: "1px solid blue" }} // Debug styling
                  onClick={(event) => handleClickCancelDelivery(event, singleOrder?.id)}
                >
                  CANCEL DELIVERY
                </Link>
              </>
            ) : (
              <>
                {(singleOrder?.status === "CORRECTLY ORDERED" || singleOrder?.status === "PAID")? (
                  <Link
                    to=""
                    className="order_detail_heading_nav3_link1"
                    onClick={(event) => handleSubmit(event, singleOrder?.id)}
                  >
                    START
                  </Link>
                ) : null}
                {singleOrder?.status === "ACCEPTED" ? (
                  <Link
                    to=""
                    className="order_detail_heading_nav3_link2"
                    onClick={(event) => handleClick(event, singleOrder?.id)}
                  >
                    READY
                  </Link>
                ) : null}
                {/* {singleOrder?.status === "LOOKING FOR DRIVER" ? (
                  <Link
                    to=""
                    className="order_detail_heading_nav3_link2"
                    onClick={(event) => handleClickOngoing(event, singleOrder?.id)}
                  >
                    ON GOING
                  </Link>
                ) : null}
                {singleOrder?.status == 'DRIVER PICKED UP ORDER' ? (
                  <Link 
                    to="" 
                    className="order_detail_heading_nav3_link2" 
                    onClick={(event) => handleClickCompleted(event, singleOrder?.id)}
                  > COMPLETED 
                  </Link> 
                ): null} */}
                {(singleOrder?.status === "DELIVERY REJECTED" ||
                  singleOrder?.status === "BOOKING DELIVERY FAILED") ? (
                  <Link
                    to=""
                    className="order_detail_heading_nav3_link2"
                    onClick={(event) => handleRequestDriver(event, singleOrder?.id)}
                  >
                    Request Driver
                  </Link>
                ) : null}
              </>
            )}
          </div>

          <div style={{ display: "none" }}>
            {/* <ComponentToPrint ref={componentRef}  /> */}
            <AllReceiptToPrint ref={allReceiptRef}  />
          </div>

          <Link to="#" onClick={() =>setPrintModal(true)} >
            <div className="order_detail_heading_nav4">
              <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M23.4375 15.4688C22.6611 15.4688 22.0312 16.098 22.0312 16.875C22.0312 17.6514 22.6611 18.2812 23.4375 18.2812C24.2139 18.2812 24.8438 17.6514 24.8438 16.875C24.8438 16.098 24.2139 15.4688 23.4375 15.4688ZM25.3125 10.3125V5.85234C25.3125 5.10645 25.016 4.39102 24.4887 3.86367L21.4488 0.823828C20.9215 0.296484 20.2061 0 19.4602 0H6.47344C5.48672 0 4.6875 0.839648 4.6875 1.875V10.3125C2.09883 10.3125 0 12.4113 0 15V22.5C0 23.018 0.419531 23.4375 0.9375 23.4375H4.6875V29.0625C4.6875 29.5805 5.10703 30 5.625 30H24.375C24.893 30 25.3125 29.5805 25.3125 29.0625V23.4375H29.0625C29.5805 23.4375 30 23.018 30 22.5V15C30 12.4113 27.9012 10.3125 25.3125 10.3125ZM7.5 2.8125H18.75V5.625C18.75 6.14297 19.1695 6.5625 19.6875 6.5625H22.5V10.3125H7.5V2.8125ZM22.5 27.1875H7.5V23.4375H22.5V27.1875ZM27.1875 20.625H2.8125V15C2.8125 13.9664 3.65391 13.125 4.6875 13.125H25.3125C26.3461 13.125 27.1875 13.9664 27.1875 15V20.625Z" fill="black"/>
              </svg>
              <p>Print</p>
            </div>
          </Link>
          <PrintModal printModal={printModal} setPrintModal={() =>setPrintModal(false)} />
        </div>
      </div>
      <div className="order_detail_page_inner" >
        <div className="order_detail_inner1">
          <div className="order_summary">Order summary</div>
          <div className="order_summary_inner">
            <div className="order_summary_inner_text">{singleOrder?.total_quantity} items</div>
            {singleOrder?.cuttlery ? (<>
            <div className="order_summary_inner1">
              <img src="/images/frame2.png" alt="cutlry_img" />
              Need cutlery
            </div>
            </>) : (<>
              <div className="order_summary_inner1">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="10" cy="10" r="10" fill="#ED6C30"/>
              <rect x="6" y="6" width="8" height="8" rx="2" fill="white"/>
              </svg>
              Don't need cutlery
            </div>
            </>)}
          </div>
            <div className="order_product_detail_wrapper">
            {singleOrder?.order_products.map((prod) => (
              <div className="order_detail_product" key={prod?.id}>
                <div className="order_detail_product_inner">
                  <div className="order_detail_product_inner1">
                    <p className="order_detail_product_inner1_p">{prod?.quantity} <span className="order_detail_product_inner1_span">x</span> {prod.name}</p>
                  </div>
                  <div className="order_detail_product_inner2">
                    {prod.price}
                  </div>
                </div>
                {prod?.addons !="" ? <div className="choice_of_size">Add Ons</div> : null }
                {prod?.addons?.map((AddOns) =>(
                  <>
                    <div className="choice_of_size_regular" key={AddOns?.id}>
                      <p>{AddOns?.quantity} x {AddOns?.name}</p>
                      <p>{AddOns?.price}</p>
                    </div>                    
                  </>
                ))}
                {prod?.modificators?.map((prodSize) =>(
                <>
                <div className="choice_of_size" key={prodSize?.group?.id}>{prodSize?.group?.name}</div>
                <div className="choice_of_size_regular">
                  <p>{prodSize?.group_item?.name}</p>
                  <p>{prodSize?.group_item?.price}</p>
                </div>
                </>
                ))}
                <div className="choice_of_size">{prod.addon}</div>
                <div className="choice_of_size_regular">
                  <p>{prod.addon_item}</p>
                  <p>{prod.addon_price}</p>
                </div>
                {prod.note != "" ? (
                  <>
                    <div className="order_detail_add_ons">
                      <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M14.0833 0H2.40833C1.49167 0 0.75 0.75 0.75 1.66667L0.758333 13.3333C0.758333 14.25 1.5 15 2.41667 15H10.75L15.75 10V1.66667C15.75 0.75 15 0 14.0833 0ZM4.91667 4.16667H11.5833C12.0417 4.16667 12.4167 4.54167 12.4167 5C12.4167 5.45833 12.0417 5.83333 11.5833 5.83333H4.91667C4.45833 5.83333 4.08333 5.45833 4.08333 5C4.08333 4.54167 4.45833 4.16667 4.91667 4.16667ZM7.41667 9.16667H4.91667C4.45833 9.16667 4.08333 8.79167 4.08333 8.33333C4.08333 7.875 4.45833 7.5 4.91667 7.5H7.41667C7.875 7.5 8.25 7.875 8.25 8.33333C8.25 8.79167 7.875 9.16667 7.41667 9.16667ZM9.91667 13.75V10C9.91667 9.54167 10.2917 9.16667 10.75 9.16667H14.5L9.91667 13.75Z" fill="#0F1B1A"/>
                      </svg>
                      {prod.note}
                    </div>
                  </>
                ):null}
              </div>
            ))}
            <div className="order_detail_page_price">
              <div className="order_price_top">
                <div className="order_subtotal">
                  <p> Subtotal </p>
                  <p> RM{singleOrder?.total_price} </p>
                </div>
                <div className="order_subtotal">
                  <p> Incl. Tax (SST %6) </p>
                  <p> RM{singleOrder?.include_tax} </p>
                </div>
                <div className="order_delivery">
                  <p>Delivery Fee</p>
                  <p>{singleOrder?.delivery_fee}</p>
                </div>
                {(singleOrder?.discount_data.length === 0 || singleOrder?.discount_data?.price_value > 0) ? ( 
                <div className="order_promo">
                  <p>{singleOrder?.discount_data?.name} Promo</p>
                  <p>-RM{singleOrder?.discount_data?.price_value}</p>
                </div>
                ) : ("")}
                {(singleOrder?.voucher_amount > 0) ? ( 
                <div className="order_promo">
                  <p>Voucher {singleOrder?.voucher_title}</p>
                  <p>-RM{singleOrder?.voucher_amount}</p>
                </div>
                ) : ("")}
              </div>
              <div className="order_total">
                <p>Total</p>
                <p>RM{singleOrder?.summary_price}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="order_detail_inner2">
          <div className="order_detail_inner2_1">
            <p className="order_detail_inner2_p_1">Order Status</p>
            <p className="order_detail_inner2_p_2">{singleOrder?.status}</p>
          </div>
          <div className="order_detail_customer">
            <div className="order_detail_customer_1">
              <p className="order_detail_customer_p1">Customer</p>
              <p className="order_detail_customer_p2">{singleOrder?.user?.full_name}</p>
              <p className="order_detail_customer_p3">Ordered {singleOrder?.user?.completed_order_counts} times</p>
            </div>
            <div className="order_detail_customer_1">
              <p className="order_detail_customer_p4">Phone number</p>
               <a href={whatsapp_url + singleOrder?.user?.phone.slice(1,singleOrder?.user?.phone.length) + '&text=Helo'} target="_blank" rel="noreferrer">
                <div className="order_phone_icon">
                  <p className="order_detail_customer_p5">{singleOrder?.user?.phone}</p>
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M2.59144 2.53624C4.23828 0.904183 6.46529 -0.00792544 8.78382 5.189e-05C11.1 -0.00376069 13.3233 0.910484 14.9668 2.54256C16.6103 4.17463 17.5401 6.39151 17.5524 8.70767V8.71719C17.5399 10.2664 17.1178 11.7847 16.3291 13.1181C15.5403 14.4515 14.4128 15.5525 13.0611 16.3094C11.7094 17.0664 10.1815 17.4523 8.63246 17.4281C7.08342 17.4039 5.56835 16.9703 4.24097 16.1715L1.46001 17.0524C1.33429 17.0922 1.20003 17.0963 1.07208 17.0645C0.944142 17.0326 0.827516 16.9659 0.735124 16.8719C0.642733 16.7778 0.578181 16.66 0.548619 16.5315C0.519057 16.403 0.525638 16.2688 0.567634 16.1439L1.45525 13.5124C0.503483 12.0921 -0.00317958 10.4203 1.50142e-05 8.71053V8.70767C0.0122397 6.38848 0.944254 4.1689 2.59144 2.53624ZM8.78287 0.714337L8.78097 1.42862C6.84036 1.42153 4.97623 2.18473 3.59778 3.55069C2.21932 4.91665 1.43917 6.77375 1.42859 8.71434C1.42604 10.2469 1.9147 11.7399 2.82287 12.9743C2.8911 13.0669 2.93599 13.1745 2.95373 13.288C2.97147 13.4016 2.96154 13.5178 2.92478 13.6267L2.3724 15.2648L4.12478 14.7096C4.22592 14.6775 4.33294 14.6684 4.43804 14.6829C4.54314 14.6974 4.6437 14.7352 4.7324 14.7934C5.83686 15.5186 7.11629 15.9328 8.4362 15.9926C9.75611 16.0524 11.0677 15.7554 12.2332 15.133C13.3987 14.5106 14.375 13.5857 15.0594 12.4556C15.7439 11.3254 16.1112 10.0317 16.1229 8.71053C16.1113 6.77308 15.3327 4.91912 13.9574 3.55439C12.5821 2.18966 10.7223 1.42531 8.78478 1.42862L8.78287 0.714337ZM6.85525 4.31243C7.06764 4.42196 7.30287 4.61053 7.4324 4.91053C7.48478 5.03053 7.55811 5.20958 7.6343 5.39624L7.80287 5.80577C7.86954 5.96481 7.93049 6.10672 7.98002 6.21339C8.00478 6.26672 8.02287 6.30481 8.03525 6.32767V6.32958C8.14355 6.49328 8.20582 6.6831 8.21554 6.87915C8.22526 7.0752 8.18207 7.27025 8.09049 7.44386C8.02443 7.58026 7.93333 7.70302 7.82192 7.80577C7.79988 7.82597 7.77766 7.84597 7.75525 7.86577L7.70954 7.90862C8.28935 8.73428 9.07191 9.3968 9.98192 9.83243C10.0629 9.72196 10.1533 9.59148 10.2219 9.48291C10.3705 9.24862 10.6124 9.03529 10.9619 8.99434C11.2257 8.96386 11.4572 9.05339 11.5467 9.08767L11.5553 9.09148C11.7457 9.16386 12.5676 9.56481 12.9124 9.73243L13.0419 9.79529C13.06 9.80386 13.08 9.81434 13.1029 9.82386C13.1762 9.8591 13.2676 9.90196 13.3372 9.941C13.4181 9.98577 13.62 10.0991 13.7505 10.322C13.7886 10.3867 13.8143 10.4553 13.8295 10.5248C13.9112 10.7736 13.9351 11.0377 13.8995 11.2971C13.8638 11.5565 13.7696 11.8044 13.6238 12.022C12.8657 13.3353 11.5543 13.7458 10.2429 13.6096C8.95144 13.4762 7.59049 12.822 6.46954 11.9334C5.34763 11.0439 4.38382 9.85434 3.96478 8.56386C3.5343 7.23719 3.68573 5.79815 4.82097 4.5991C5.20287 4.18386 5.77335 4.09434 6.18192 4.12672C6.40383 4.14386 6.64097 4.201 6.85525 4.31243ZM12.4838 11.1115L12.421 11.082L12.2543 11.001C11.9197 10.8385 11.5844 10.6772 11.2486 10.5172C11.1335 10.685 11.0095 10.8465 10.8772 11.001C10.7505 11.1439 10.5438 11.3124 10.2391 11.3496C10.0136 11.372 9.7865 11.3279 9.58573 11.2229C8.23328 10.6296 7.09235 9.64046 6.31335 8.38577L6.30382 8.37053C6.22294 8.24055 6.17351 8.0935 6.15946 7.94106C6.1454 7.78862 6.16712 7.635 6.22287 7.49243C6.30478 7.28672 6.45906 7.13148 6.48573 7.10386C6.56043 7.02807 6.63664 6.95376 6.7143 6.881C6.63401 6.7073 6.55717 6.53203 6.48383 6.35529L6.30287 5.91434C6.25575 5.79826 6.20813 5.68239 6.16002 5.56672C6.06181 5.54005 5.9578 5.54403 5.86192 5.57815C5.13811 6.34005 5.02859 7.21339 5.32382 8.12291C5.63144 9.07053 6.38382 10.0429 7.35716 10.8143C8.32954 11.5858 9.44097 12.0905 10.3895 12.1886C11.3067 12.2839 11.9924 12.0048 12.3972 11.2905C12.4083 11.2706 12.4203 11.2512 12.4333 11.2324C12.4586 11.1963 12.4755 11.155 12.4829 11.1115H12.4838ZM5.87144 5.56577L5.86954 5.56862L5.87144 5.56577ZM6.20097 5.58291H6.20002H6.20192H6.20097Z" fill="black"/>
                  </svg>
                </div>
              </a>
              {/* </Link> */}
            </div>
          </div>
          <div className="order_detail_address">
            <div className="order_detail_address_inner1">
              <div className="order_address_icon">
                <p className="order_detail_address_p1">Deliver to</p>
                <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11.6667 6.33333C11.6667 9.33524 9.58095 11.0619 8.0181 12.7333C7.0819 13.7343 6.33333 17 6.33333 17C6.33333 17 5.58667 13.7371 4.65333 12.7381C3.08857 11.0676 1 9.3381 1 6.33333C1 4.91885 1.5619 3.56229 2.5621 2.5621C3.56229 1.5619 4.91885 1 6.33333 1C7.74782 1 9.10438 1.5619 10.1046 2.5621C11.1048 3.56229 11.6667 4.91885 11.6667 6.33333Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4.19995 6.33335C4.19995 6.6135 4.25513 6.89091 4.36234 7.14974C4.46955 7.40856 4.62669 7.64374 4.82479 7.84184C5.02289 8.03994 5.25807 8.19708 5.51689 8.30429C5.77572 8.4115 6.05313 8.46668 6.33329 8.46668C6.61344 8.46668 6.89085 8.4115 7.14968 8.30429C7.4085 8.19708 7.64368 8.03994 7.84178 7.84184C8.03988 7.64374 8.19702 7.40856 8.30423 7.14974C8.41144 6.89091 8.46662 6.6135 8.46662 6.33335C8.46662 5.76755 8.24186 5.22493 7.84178 4.82485C7.4417 4.42477 6.89908 4.20001 6.33329 4.20001C5.76749 4.20001 5.22487 4.42477 4.82479 4.82485C4.42471 5.22493 4.19995 5.76755 4.19995 6.33335Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <p className="order_detail_address_p2">{singleOrder?.address_data?.formatted_address}</p>
              <p className="order_detail_address_p3">(“{singleOrder?.address_data?.remarks}”)</p>
            </div>
            <div className="order_detail_address_inner2">
              <p className="order_detail_address_p4">Order Time</p>
              <p className="order_detail_address_p5">{singleOrder?.created_at} ASAP </p>
            </div>
          </div>
          {singleOrder?.delivery && ["DRIVER IS ON THE WAY", "DRIVER PICKED UP ORDER", "READY", "ACCEPTED", "DELIVERY ORDER RETRYING"].includes(singleOrder?.status) ? (
              <>
                <div className="order_detail_driver">
                  <div className="order_driver_detail">
                    <p className="order_driver_detail_p1">Driver grab Name</p>
                    <div className="driver_icon">
                     {/* <Link to='/map'> */}
                      <p className="order_driver_detail_name">{singleOrder?.delivery?.driver_name}</p>
                      {/* <svg width="13" height="18" viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M11.6667 6.33333C11.6667 9.33524 9.58095 11.0619 8.0181 12.7333C7.0819 13.7343 6.33333 17 6.33333 17C6.33333 17 5.58667 13.7371 4.65333 12.7381C3.08857 11.0676 1 9.3381 1 6.33333C1 4.91885 1.5619 3.56229 2.5621 2.5621C3.56229 1.5619 4.91885 1 6.33333 1C7.74782 1 9.10438 1.5619 10.1046 2.5621C11.1048 3.56229 11.6667 4.91885 11.6667 6.33333Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M4.19995 6.33335C4.19995 6.6135 4.25513 6.89091 4.36234 7.14974C4.46955 7.40856 4.62669 7.64374 4.82479 7.84184C5.02289 8.03994 5.25807 8.19708 5.51689 8.30429C5.77572 8.4115 6.05313 8.46668 6.33329 8.46668C6.61344 8.46668 6.89085 8.4115 7.14968 8.30429C7.4085 8.19708 7.64368 8.03994 7.84178 7.84184C8.03988 7.64374 8.19702 7.40856 8.30423 7.14974C8.41144 6.89091 8.46662 6.6135 8.46662 6.33335C8.46662 5.76755 8.24186 5.22493 7.84178 4.82485C7.4417 4.42477 6.89908 4.20001 6.33329 4.20001C5.76749 4.20001 5.22487 4.42477 4.82479 4.82485C4.42471 5.22493 4.19995 5.76755 4.19995 6.33335Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg> */}
                      {/* </Link> */}
                    </div>
                  </div>
                  <div className="order_driver_detail1">
                    <p className="order_driver_detail_p2">Driver Number</p>
                    <p className="order_driver_detail_p3">{singleOrder?.delivery?.driver_phone}</p>
                  </div>
                  <div className="order_driver_detail1">
                    <p className="order_driver_detail_p2">Tracking Url</p>
                    <a href={singleOrder?.delivery?.driver_share_link} target="_blank" rel="noreferrer">
                      <p className="order_driver_detail_p3">
                        {singleOrder?.delivery?.driver_share_link}
                      </p>
                    </a>
                  </div>
                </div>
                <div className="order_driver_border"></div>
              </>
          ) : (<>
            <div className="order_driver_border_later"></div>
          </>) }
          {!["DRIVER IS ON THE WAY", "DRIVER PICKED UP ORDER", "LOOKING FOR DRIVER"].includes(singleOrder?.status) ? 
          <div className={`driver_botton ${["DELIVERY REJECTED", "BOOKING DELIVERY FAILED"].includes(singleOrder?.status) ? "driver_botton_row" : ""}`}>
            {["DELIVERY REJECTED", "BOOKING DELIVERY FAILED"].includes(singleOrder?.status) ? (
              <Link
                to=""
                className="driver_botton2 driver_botton_complete"
                onClick={(event) => handleClickCompleted(event, singleOrder?.id)}
              >
                COMPLETED
              </Link>
            ) : null}
            <Link to="" className="driver_botton1" onClick={() =>setIsOpen(true)}>CANCEL</Link>
            {/* <Link to="" className="driver_botton2" onClick={() =>setIsOptions(true)} >OPTIONS</Link> */}
          </div>: null
          }
          <CancelModal isOpen={isOpen} setIsOpen={() =>setIsOpen(false)} />
          <OptionModal isOptions={isOptions} setIsOptions={() =>setIsOptions(false)} />
        </div>
      </div>
    </div>
  )
}

export default OrderDetail
